import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { ApplicationStateService } from '../../../services/application-state.service';
import { SalesChannel } from '../../../../core/consts/sales-channel.enum';
import { DialogConfigBase } from '../dialog-config-base';
import { DialogConfigInterface } from '../dialog-config.interface';
import { DialogComponentInterface } from '../dialog-component.interface';

@Component({
  selector: 'app-waiting-offer-dialog-dialog',
  templateUrl: './waiting-offer-dialog.component.html',
})
export class WaitingOfferDialogComponent implements OnInit, DialogComponentInterface {

  static getConfigBuilder(): any {
    return new WaitingOfferDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: WaitingOfferDialogData,
              private stateService: ApplicationStateService) {
  }

  get showProgressBar(): boolean {
    return this.stateService.salesChannel === SalesChannel.YANOSIK;
  }

  get totalAmountOfOffers(): number {
    return this.stateService.displayedOffersNumber;
  }

  get progressBarValue(): number {
    return this.stateService.foundOffersPercent;
  }

  ngOnInit() {
  }

}

export class WaitingOfferDialogConfig extends DialogConfigBase implements DialogConfigInterface {

  private config: MatDialogConfig = {
    panelClass: 'app-dialog',
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: WaitingOfferDialogData): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}

export interface WaitingOfferDialogData {
  header: string,
  imageSrc: string,
  offersMessage: string,
  analysisMessage: string,
  footer: string,
  displayTime: number
}

